import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './usuarioForm';
import Select from '../common/form/select';

import { setModoTela, initForm, salvar, excluir, getLista, getListaMotorista, alterarPermissoes, alterarNotificacao } from './usuarioActions';

class Usuario extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaMotorista();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								disabled={this.props.permissoes.acesso_usuario != 2}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({  usuario: true, ponto_atendimento: false, vendedor: false });
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive style={{ marginBottom: 100 }}>
						<THead>
							<Tr>
								<Th colspan={1}>Nome</Th>
								<Th colspan={1}>Login</Th>
								<Th width={100} colspan={1} alignCenter>Dashboard Simplificada</Th>
								<Th width={100} colspan={1} alignCenter>Usuário</Th>
								<Th width={100} colspan={1} alignCenter>Cadastros</Th>
								<Th width={150} colspan={1} alignCenter>Logística</Th>
								<Th width={100} colspan={1} alignCenter>Viagem Lançamento</Th>
								<Th width={100} colspan={1} alignCenter>Despesas</Th>
								<Th width={100} colspan={1} alignCenter>Aprovação</Th>
								<Th width={100} colspan={1} alignCenter>Checklist</Th>
								<Th width={100} colspan={1} alignCenter>Dashboard Logística</Th>
								<Th width={100} colspan={1} alignCenter>Dashboard Oficina</Th>
								<Th width={100} colspan={1} alignCenter>Dashboard Financeiro</Th>
								<Th width={300} colspan={1} alignCenter>Notificação</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista
								.filter(item => {
									if (this.state.pesquisar
										&& !(`${item.nome} ${item.login}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
										return false;
									}
									return true;
								}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome}</Td>
									<Td>{item.login}</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Utiliza a dashboard simplificada'
													class={`btn btn-${item.dashboard_simplificada ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, dashboard_simplificada: !item.dashboard_simplificada })}><i class='fa fa-eye'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite visualizar'
													class={`btn btn-${item.acesso_usuario > 0 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_usuario: item.acesso_usuario == 1 ? 0 : 1 })}><i class='fa fa-eye'></i>
												</button>
												<button type='button'
													title='Permite editar'
													class={`btn btn-${item.acesso_usuario > 1 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_usuario: item.acesso_usuario == 2 ? 0 : 2 })}><i class='fa fa-pencil-alt'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite visualizar'
													class={`btn btn-${item.acesso_cadastro > 0 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_cadastro: item.acesso_cadastro == 1 ? 0 : 1 })}><i class='fa fa-eye'></i>
												</button>
												<button type='button'
													title='Permite editar'
													class={`btn btn-${item.acesso_cadastro > 1 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_cadastro: item.acesso_cadastro == 2 ? 0 : 2 })}><i class='fa fa-pencil-alt'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite visualizar'
													class={`btn btn-${item.acesso_logistica > 0 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_logistica: item.acesso_logistica == 1 ? 0 : 1 })}><i class='fa fa-eye'></i>
												</button>
												<button type='button'
													title='Permite editar'
													class={`btn btn-${item.acesso_logistica > 1 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_logistica: item.acesso_logistica == 2 ? 0 : 2 })}><i class='fa fa-pencil-alt'></i>
												</button>
												<button type='button'
													title='Admin'
													class={`btn btn-${item.acesso_logistica_admin ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_logistica_admin: !item.acesso_logistica_admin })}><i class='fas fa-user-tie'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite visualizar'
													class={`btn btn-${item.acesso_viagem > 0 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_viagem: item.acesso_viagem == 1 ? 0 : 1 })}><i class='fa fa-eye'></i>
												</button>
												<button type='button'
													title='Permite editar'
													class={`btn btn-${item.acesso_viagem > 1 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_viagem: item.acesso_viagem == 2 ? 0 : 2 })}><i class='fa fa-pencil-alt'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite visualizar'
													class={`btn btn-${item.acesso_despesa > 0 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_despesa: item.acesso_despesa == 1 ? 0 : 1 })}><i class='fa fa-eye'></i>
												</button>
												<button type='button'
													title='Permite editar'
													class={`btn btn-${item.acesso_despesa > 1 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_despesa: item.acesso_despesa == 2 ? 0 : 2 })}><i class='fa fa-pencil-alt'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite aprovar despesas'
													class={`btn btn-${item.aprova_despesa ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, aprova_despesa: !item.aprova_despesa })}><i class='fa fa-pencil-alt'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite acessar checklists'
													class={`btn btn-${item.acesso_checklist == 2 ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, acesso_checklist: item.acesso_checklist == 2 ? 0 : 2 })}><i class='fa fa-pencil-alt'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite acessar o dashboard da logística'
													class={`btn btn-${item.dashboard_logistica ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, dashboard_logistica: !item.dashboard_logistica })}><i class='fa fa-eye'></i>
												</button>
											</>
										) : null}
									</Td>

									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite acessar o dashboard da oficina'
													class={`btn btn-${item.dashboard_oficina ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, dashboard_oficina: !item.dashboard_oficina })}><i class='fa fa-eye'></i>
												</button>
											</>
										) : null}
									</Td>

									<Td alignCenter>
										{!item.id_motorista ? (
											<>
												<button type='button'
													title='Permite acessar o dashboard financeiro'
													class={`btn btn-${item.dashboard_financeiro ? 'success' : 'default'} btn-sm ${this.props.permissoes.acesso_usuario != 2 ? 'disabled' : ''}`}
													onClick={() => this.props.alterarPermissoes({ ...item, dashboard_financeiro: !item.dashboard_financeiro })}><i class='fa fa-eye'></i>
												</button>
											</>
										) : null}
									</Td>
									<Td alignCenter>
										{!item.id_motorista ? (
											<Select
												cols='12 12 12 12'
												options={this.props.listaNotificacaoPerfil}
												multiple
												value={(item.notificacao_perfil || []).map(notificacao => ({
													value: notificacao,
													label: this.props.listaNotificacaoPerfil.filter(perfil => perfil.id == notificacao).map(perfil => perfil.valor).join()
												}))}
												onChange={data => {
													this.props.alterarNotificacao({
														...item,
														notificacao_perfil: (data || []).map(notificacao => notificacao.value)
													})
												}} />
										) : null}
									</Td>

									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											disabled={this.props.permissoes.acesso_usuario != 2}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											disabled={this.props.permissoes.acesso_usuario != 2}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	permissoes: state.usuario.permissoes,
	modoTela: state.usuario.modoTela,
	lista: state.usuario.lista,
	permissoes: state.usuario.permissoes,
	listaNotificacaoPerfil: state.usuario.listaNotificacaoPerfil
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, getListaMotorista, alterarPermissoes, alterarNotificacao }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Usuario);
